
import BitcoinCard from "../../../assets/filled/BitcoinCard.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function BitcoinCardIcon({ className, dataTestid = "BitcoinCardIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <BitcoinCard data-testid={dataTestid} className={classes} {...rest} />
  );
}
